import React from 'react'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import { SvgClose } from '@ntuctech/devex-tangram/Icon'
import ButtonIcon from '@ntuctech/devex-tangram/Button/ButtonIcon'
import { ImageDiv, ContentText } from './LoginScreen/elements'
import ntucCardBack from './icons/ntuc-card-back.png'
import ntucCardFront from './icons/ntuc-card-front.png'
import ntucLinkCard from './icons/ntuc-link-card.png'
import ntucLinkTrustVisa from './icons/ntuc-link-trust-visa-card.png'
import linkCard from './icons/link-card.png'
import trustVisa from './icons/trust-link-visa-card.png'
import neboCard from './icons/nebo-card.png'
import CardsDetails from './CardsDetails'
import { SCREEN_SIZE } from '../../lib/Media'

const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-width: 100vw;
  z-index: 99;
`
const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  min-height: 100vh;
  height: 100%;
  min-width: 100vw;
  z-index: 100;
`

const Modal = styled.div`
  background-color: white;
  border-radius: 0.25rem;
  width: calc(100vw - 1rem);
  height: calc(100vh - 2rem);
  max-width: 26.25rem;
  padding: 1.5rem;
  margin: 1rem 0;
  z-index: 101;

  ${SCREEN_SIZE.From.Tablet} {
    height: auto;
  }
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ModalTitle = styled.div`
  font-size: 1.3rem;
  font-weight: bold;
`
const NtucCardFront = styled(Image).attrs({
  src: ntucCardFront,
  loading: 'eager',
  objectfit: 'contain',
  layout: 'fill',
})``

const NtucCardBack = styled(Image).attrs({
  src: ntucCardBack,
  loading: 'eager',
  objectfit: 'contain',
  layout: 'fill',
})``

const ModalContent = styled.div`
  overflow-y: scroll;
  height: calc(100% - 2rem);
`

const CardsSvgWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.6rem;
  margin: 1rem;
`

const eligibleCardsData = [
  {
    src: ntucLinkCard,
    text: 'NTUC card',
    eligible: true,
  },
  {
    src: ntucLinkTrustVisa,
    text: 'NTUC Link Credit/Debit card',
    eligible: true,
  },
  {
    src: linkCard,
    text: 'Link card*',
    eligible: true,
  },
  {
    src: trustVisa,
    text: 'Trust Link Credit/Debit card*',
    eligible: true,
  },
]

const ineligibleCardsData = [
  {
    src: neboCard,
    text: 'nEbO card',
  },
]

const CardInfoModal = ({ open, onClose }) => {
  if (!open) {
    return null
  }

  return (
    <ModalWrapper data-testid="card-info-modal">
      <ModalOverlay onClick={onClose} />
      <Modal>
        <ModalHeader>
          <ModalTitle>Link Rewards card number</ModalTitle>
          <ButtonIcon
            data-testid="card-info-close-button"
            onClick={onClose}
            color="grey"
          >
            <SvgClose />
          </ButtonIcon>
        </ModalHeader>
        <ModalContent>
          <ContentText>
            Your 16-digit card number is displayed on the front or back of your
            card.
          </ContentText>
          <CardsSvgWrapper>
            <ImageDiv>
              <NtucCardFront />
            </ImageDiv>
            <ImageDiv>
              <NtucCardBack />
            </ImageDiv>
          </CardsSvgWrapper>
          <ContentText>
            For Trust Credit/Debit cardholders, please use the FairPrice Group
            app or check your physical receipt to find your 16-digit card number
            that starts with 8202 or 8302.
          </ContentText>
          <CardsDetails
            title="Eligible Cards"
            details={eligibleCardsData}
            footnotes={[
              '* Eligible cardholders only.',
              'Enter 16-digit card number starting with 8202 or 8302 to check eligibility.',
            ]}
          />
          <CardsDetails
            title="Ineligible Cards"
            details={ineligibleCardsData}
          />
        </ModalContent>
      </Modal>
    </ModalWrapper>
  )
}

export default CardInfoModal
